import React from 'react'
import "./header.css";

const Header = () => {
    return <div className="header">
        <p className="glyph" id="home-header">zach's website</p>
        <p className="glyph" style={{fontSize: "0.75rem"}}>now with fun backgrounds</p>
    </div>;
}

export default Header;